var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slot-master',{attrs:{"show-modal":true},on:{"update:showModal":_vm.onToggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }